import './App.css';
import React from 'react'
import Navbar from './components/Navbar/Navbar';
import Banner from './components/Banner/Banner';
import Rowpost from './components/Rowpost/Rowpost';
import {orginals,action,comedy,horror,documentarie} from './urls'


function App() {
  return (
    <div className="App">
      <Navbar />
     <Banner />
     <Rowpost url={orginals} title='Netflix Originals'/>
     <Rowpost url={action} title='Action' isSmall />
     <Rowpost url={comedy} title='Comedy' isSmall/>
     <Rowpost url={horror} title='Horror' isSmall/>
     <Rowpost url={documentarie} title='Documentaries' isSmall/>
    </div>
  );
}

export default App;
